import { render, staticRenderFns } from "./LogoSquareIcon.vue?vue&type=template&id=624e8e6e&"
import script from "./LogoSquareIcon.vue?vue&type=script&lang=ts&"
export * from "./LogoSquareIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports